import Languages, { isoLanguageCodes, LanguageInfo } from "../store/Languages";

export type ExtendedLanguageInfo = LanguageInfo & {
  htmlLangValue: isoLanguageCodes;
};

/**
 * Gets the selected language content and appends on the HTML lang value
 */
export function getExtendedLanguageInfo(
  languageCode: isoLanguageCodes
): ExtendedLanguageInfo | undefined {
  let selectedLanguage!: ExtendedLanguageInfo;
  for (const language of Object.keys(Languages)) {
    if (language === languageCode) {
      selectedLanguage = {
        ...Languages[languageCode],
        htmlLangValue: languageCode
      };
      break;
    }
  }
  return selectedLanguage;
}
